import { Icon } from '@iconify/react';
import Link from 'next/link';

export default function Breadcrumbs({ items }) {
  return (
    <div className="flex flex-wrap items-center gap-4">
      {items.map(({ url, text }, i) => (
        <span key={i} className="flex items-center gap-4">
          {i === items.length - 1 ? (
            text
          ) : (
            <Link href={url}>
              <a className="text-primary-500 hover:underline hover:underline-offset-4 focus-visible:outline-dashed focus-visible:outline-offset-2 focus-visible:outline-primary-200">
                {text}
              </a>
            </Link>
          )}
          {i < items.length - 1 && (
            <Icon className="text-neutral-500" icon="fluent:chevron-right-12-filled" />
          )}
        </span>
      ))}
    </div>
  );
}
